import { render, staticRenderFns } from "./ErrorsDialog.vue?vue&type=template&id=2b18e359&scoped=true&"
import script from "./ErrorsDialog.vue?vue&type=script&lang=js&"
export * from "./ErrorsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ErrorsDialog.vue?vue&type=style&index=0&id=2b18e359&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18e359",
  null
  
)

export default component.exports